/**
 * Optionsliste für ein `<select>`, die den gesetzten Wert IMMER enthält.
 *
 * 🔴 Gemeldet am 25.08.2026 von Paul zu den internen Aufgaben: „paul ist
 * zugewiesen aber hinten steht niemand". Der Filter „Meine (Paul)" fand die
 * Aufgabe — im Auswahlfeld daneben stand trotzdem „— niemand —".
 *
 * Die Ursache ist ein bekannter Fallstrick, hier zum zweiten Mal (zuerst im
 * Kalender-Bearbeiten-Fenster, `63ae8c2`): ein controlled `<select value={x}>`,
 * dessen Optionen aus einer Query kommen, zeigt den Platzhalter, solange zu `x`
 * kein passender `<option>` existiert. Das passiert
 *
 *   * im Ladefenster der Query,
 *   * wenn die Query fehlschlägt,
 *   * und dauerhaft, wenn der Wert gar nicht mehr in der Liste steht — etwa
 *     weil der zuständige Zugang deaktiviert wurde.
 *
 * Der letzte Fall ist der schlimmste: „niemand zuständig" und „zuständig ist
 * jemand, den die Liste nicht mehr kennt" sehen identisch aus, und niemand
 * kümmert sich.
 */

export function mitGesetztemWert(werte: string[], wert?: string | null): string[] {
  const w = (wert || "").trim()
  if (!w || werte.includes(w)) return werte
  // Vorne einsortieren: der gesetzte Wert ist das, was gerade gilt.
  return [w, ...werte]
}
